import theme from '@themes/theme';

export type PlanType =
  | 'Team'
  | 'team-trial'
  | 'team-expired'
  | 'basic'
  | 'cancelled';

interface PlanTagContent {
  icon: string;
  text: string;
  bgColor: string;
  textColor: string;
  iconColor: keyof typeof theme.colors;
}

export function getPlanTagContent(type: PlanType): PlanTagContent {
  switch (type) {
    case 'Team':
      return {
        icon: 'Crown',
        text: 'Team Plan',
        bgColor: theme.colors.greenSecondaryMild,
        textColor: theme.colors.greenSecondary,
        iconColor: 'greenSecondary',
      };
    case 'team-trial':
      return {
        icon: 'ClockBlue',
        text: 'Team Plan (Free Trial)',
        bgColor: theme.colors.blueMild,
        textColor: theme.colors.pastelBlue,
        iconColor: 'pastelBlue',
      };
    case 'team-expired':
      return {
        icon: 'Slash',
        text: 'Team Plan (Expired)',
        bgColor: theme.colors.alertRedMild,
        textColor: theme.colors.alertRed,
        iconColor: 'alertRed',
      };
    case 'cancelled':
      return {
        icon: 'AlertTraingleOrange',
        text: 'Cancelled',
        bgColor: theme.colors.orangeMild,
        textColor: theme.colors.pastelOrange,
        iconColor: 'pastelOrange',
      };
    case 'basic':
      return {
        icon: 'Plant',
        text: 'Basic Plan',
        bgColor: theme.colors.greenSecondaryMild,
        textColor: theme.colors.greenSecondary,
        iconColor: 'greenSecondary',
      };
    default:
      return {
        icon: 'Crown',
        text: 'Team Plan',
        bgColor: theme.colors.greenSecondaryMild,
        textColor: theme.colors.greenSecondary,
        iconColor: 'greenSecondary',
      };
  }
}
